// 포스터는 언어+방향 칸마다 1장만 둘 수 있다.
// DB 에 같은 칸 포스터가 이미 2장 이상 있으면 편집 화면은 첫 장만 보여주므로,
// 저장 전 중복 검사와 칸별 경고가 같은 기준을 쓰도록 여기로 모은다. (BEE-5597)

interface PosterSlotItem {
  language?: string;
  orientation?: string;
}

export const posterSlotKey = (language?: string, orientation?: string): string =>
  `${(language || '').toLowerCase()}-${orientation || ''}`;

export const countPostersInSlot = (
  posters: PosterSlotItem[],
  language: string,
  orientation: string
): number => {
  const key = posterSlotKey(language, orientation);
  return posters.filter(p => posterSlotKey(p.language, p.orientation) === key).length;
};

export const findDuplicatePosterSlots = (posters: PosterSlotItem[]): string[] => {
  const counts = posters.reduce<Record<string, number>>((acc, p) => {
    const key = posterSlotKey(p.language, p.orientation);
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
  return Object.entries(counts)
    .filter(([, cnt]) => cnt > 1)
    .map(([key]) => key);
};

export const duplicatePosterSlotMessage = (duplicates: string[]): string =>
  `Duplicate language/aspect ratio combination: ${duplicates.join(', ')}. ` +
  'Each slot can hold only one poster. Click X on the slot marked in red until it is empty, ' +
  'then upload the new poster and save again.';
